import { css } from "@emotion/react";
import colors from "assets/css/colors";
import { getBlackedOutCss } from "assets/css/opacity.css";
import scrollCss from "assets/css/scroll.css";

export const tableWrapperCss = css`
  overflow-x: auto;
  position: relative;
`;

export const getTableWrapperCss = ({ isCustomScroll }) => {
  if (isCustomScroll) {
    return [tableWrapperCss, scrollCss];
  }

  return tableWrapperCss;
};
export const cellMinHeightCss = css`
  min-height: 56px;
`;

export const headerGroupCss = css`
  display: flex;
  background-color: ${colors.bgGrey};
`;

export const baseCellCss = css`
  padding: 0 16px;
  background-color: inherit;
`;

export const tableBodyCss = css`
  margin-top: 14px;
  gap: 8px;
`;

export const rowCss = css`
  display: flex;
  border-radius: 4px;
  background-color: ${colors.white};
`;

export const getRowCss = ({ isDataUpdating }) => [rowCss, getBlackedOutCss({ isDataUpdating })];

export const cellCss = [
  baseCellCss,
  cellMinHeightCss,
  css`
    position: relative;

    &:first-of-type {
      border-top-left-radius: inherit;
      border-bottom-left-radius: inherit;
    }

    &:last-of-type {
      border-top-right-radius: inherit;
      border-bottom-right-radius: inherit;
    }

    &:before {
      content: "";
      position: absolute;
      top: 12px;
      bottom: 12px;
      width: 1px;
      background-color: ${colors.strokeGrey};
      left: 0;
    }
  `,
];

export const cellNoDividerCss = [
  cellCss,
  css`
    &:before {
      display: none;
    }
  `,
];
